import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AdminLogs } from '@type/log.type';
import { basePostRequest, BasePostRequest } from '@type/request.type';
import { ListWithPagination } from '@type/table-data.type';
import { joinUrls } from '@utils/urls';
import { map } from 'rxjs';

@Injectable()
export class LogService {
  private http = inject(HttpClient);

  getLogs(request: BasePostRequest = basePostRequest) {
    return this.http
      .post<
        ListWithPagination<{ super_admin_logs: AdminLogs[] }>
      >(joinUrls(environment.urls.super_admin_logs, environment.urls.index), request)
      .pipe(map(({ meta, super_admin_logs }) => ({ ...meta, length: meta.total_count, data: super_admin_logs })));
  }

  getCompanyLogs(companyId: number, request: BasePostRequest = basePostRequest) {
    const { proxies, log, super_admin_logs } = environment.urls;
    return this.http
      .post<
        ListWithPagination<{ super_admin_logs: AdminLogs[] }>
      >(joinUrls(proxies, String(companyId), log, super_admin_logs), request)
      .pipe(map(({ meta, super_admin_logs }) => ({ ...meta, length: meta.total_count, data: super_admin_logs })));
  }
}
